import React from 'react';
import { Emoji } from './Emoji';
export function Footer() {
  return <footer className="w-full bg-forest-900 py-12 sm:py-14" data-id="element-89" data-mp="3gf93arl2hy6u">
      <div className="mx-auto w-full max-w-[680px] px-4 text-center sm:px-6" data-id="element-90" data-mp="3ggtx2ezk5d3n">
        <span className="inline-flex items-center gap-2 font-display text-sm font-extrabold uppercase tracking-[0.2em] text-cream sm:text-base sm:tracking-[0.24em]" data-id="element-91" data-mp="32ovukn0cqfgg">
          <Emoji symbol="🌿" data-id="element-92" data-mp="3ufa4y995p9nd" />
          Close The Gap<span className="text-lime-400" data-id="element-93" data-mp="3ugbrb9vmhike">™</span>
        </span>
        <p className="mx-auto mt-4 max-w-md text-[14px] leading-relaxed text-cream/70 sm:text-[15px]" data-id="element-94" data-mp="39922nzchmct">
          El sistema de alimentación N°1 para argentinos que quieren comer bien
          sin perder el tiempo. Porque comer bien no debería costarte todos los
          domingos del año.
        </p>

        <ul className="mt-8 flex flex-col items-center gap-3 sm:flex-row sm:flex-wrap sm:justify-center sm:gap-x-7" data-id="element-95" data-mp="29ynmjnzj5bfl">
          <li data-id="element-96" data-mp="2ezb9nykn184j">
            <a href="mailto:closethegap14@gmail.com" className="inline-flex items-center gap-2 break-all text-[13px] text-cream/80 transition-colors duration-150 ease-out hover:text-lime-400 sm:text-sm" data-id="element-97" data-mp="2ezuvhqdesgnu">
              <Emoji symbol="📧" data-id="element-98" data-mp="3v7gejxzbs688" />
              closethegap14@gmail.com
            </a>
          </li>
          <li data-id="element-99" data-mp="3q8wrfu8zwoea">
            <a href="https://instagram.com/closethegap14" className="inline-flex items-center gap-2 text-[13px] text-cream/80 transition-colors duration-150 ease-out hover:text-lime-400 sm:text-sm" data-id="element-100" data-mp="3q8dkf8kvvkf1">
              <Emoji symbol="📲" data-id="element-101" data-mp="33nmi62lvjkp" />
              @closethegap14
            </a>
          </li>
          <li data-id="element-102" data-mp="hsaeb79f63st">
            <a href="https://www.recursoclosethegap.shop" className="inline-flex items-center gap-2 break-all text-[13px] text-cream/80 transition-colors duration-150 ease-out hover:text-lime-400 sm:text-sm" data-id="element-103" data-mp="huwhkupa1x58">
              <Emoji symbol="🌐" data-id="element-104" data-mp="mspojpyemv6k" />
              www.recursoclosethegap.shop
            </a>
          </li>
        </ul>

        <div className="mt-10 border-t border-cream/10 pt-6" data-id="element-105" data-mp="twfnbqzkfrqu">
          <p className="flex flex-wrap items-center justify-center gap-2 font-display text-[13px] font-bold text-lime-400 sm:text-sm" data-id="element-106" data-mp="ytxy7mx58h1h">
            “Tu heladera llena el lunes empieza el domingo a las 10 de la
            mañana.”
            <Emoji symbol="🌿" data-id="element-107" data-mp="18ksod2dig0s7" />
          </p>
          <p className="mt-3 text-[11px] text-cream/45 sm:text-xs" data-id="element-108" data-mp="18ltwoz356968">
            © Close The Gap™ 2025 — Todos los derechos reservados. Prohibida la
            reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}